import { ENGINE_PATH_PREFIX } from '@gnsx/genesys.js';

/**
 * Small pure helpers for prefab create/reload flows (unit-tested without editor stores).
 */

/** Normalises prefab asset paths for stable comparison (slashes, optional leading `/@`). */
export function normalizePrefabAssetPath(prefabPath: string): string {
  const trimmed = prefabPath.trim();
  if (!trimmed) {
    return '';
  }
  const normalized = trimmed.replace(/\\/g, '/');
  return normalized.startsWith('/@') ? normalized.slice(1) : normalized;
}

/** Whether two prefab asset paths refer to the same file. */
export function prefabEditPathsMatch(a: string | null | undefined, b: string | null | undefined): boolean {
  if (!a || !b) {
    return false;
  }
  return normalizePrefabAssetPath(a) === normalizePrefabAssetPath(b);
}

/** Whether a prefab asset path lives under bundled engine content (read-only in prefab editor). */
export function isEnginePrefabPath(prefabPath: string | null | undefined): boolean {
  if (!prefabPath) {
    return false;
  }
  const normalized = normalizePrefabAssetPath(prefabPath);
  return normalized === ENGINE_PATH_PREFIX || normalized.startsWith(`${ENGINE_PATH_PREFIX}/`);
}

/** Resolves the folder used when creating a prefab asset from a caller-supplied path. */
export function resolvePrefabCreateDirectory(desiredPath: string | undefined | null, fallbackDirectory: string): string {
  const trimmed = typeof desiredPath === 'string' ? desiredPath.trim() : '';
  return trimmed !== '' ? trimmed : fallbackDirectory;
}

/** Returns actors to reload, optionally skipping the source instance (e.g. apply-to-prefab). */
export function excludeActorByUuid<T extends { uuid: string }>(actors: T[] | undefined, excludeUuid: string | undefined): T[] {
  if (!actors?.length) return [];
  if (!excludeUuid) return actors;
  return actors.filter(a => a.uuid !== excludeUuid);
}

